(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3RTuP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d115ebf5121a993$export$2e2bcd8739ae039; });

var $7gIxp = parcelRequire("7gIxp");
class $2d115ebf5121a993$export$2e2bcd8739ae039 {
    constructor({ canvas: canvas, width: width = 500, height: height = 500, padding: padding = 20, context: context = "2d", fps: fps = 60 }){
        this.canvas = canvas;
        this.ctx = this.canvas.getContext(context);
        this.canvas.setAttribute("width", width);
        this.canvas.setAttribute("height", height);
        this.width = width;
        this.height = height;
        this.centerX = width / 2;
        this.centerY = height / 2;
        this.padding = padding;
        this.innerWidth = this.width - 2 * this.padding;
        this.innerHeight = this.height - 2 * this.padding;
        this.drawId = null;
        this.fps = fps;
    }
    setup() {}
    update() {}
    draw() {}
    mouseClick(x, y) {}
    async start() {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.canvas.addEventListener("click", this.eventClick.bind(this), false);
        await this.setup();
        this.drawId = requestAnimationFrame(this.tick.bind(this));
    }
    tick() {
        const startTime = Date.now();
        this.update();
        this.draw();
        const endTime = Date.now();
        const deltaTime = endTime - startTime;
        const waitTime = 1000 / this.fps - deltaTime;
        if (waitTime > 0) setTimeout(()=>{
            this.drawId = requestAnimationFrame(this.tick.bind(this));
        }, waitTime);
        else this.drawId = requestAnimationFrame(this.tick.bind(this));
    }
    eventClick(e) {
        // get position of cursor relative to top left of canvas
        let x;
        let y;
        if (e.pageX || e.pageY) {
            x = e.pageX;
            y = e.pageY;
        } else {
            x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        x -= this.canvas.offsetLeft;
        y -= this.canvas.offsetTop;
        this.mouseClick(x, y);
    }
    clear() {
        this.ctx.clearRect(0, 0, this.width, this.height);
    }
    drawRectangle(x, y, w, h, color) {
        this.ctx.beginPath();
        this.ctx.rect(x, y, w, h);
        this.ctx.closePath();
        this.ctx.fillStyle = color;
        this.ctx.fill();
    }
    drawCircle(x, y, r, color) {
        this.ctx.beginPath();
        this.ctx.arc(x, y, r, 0, Math.PI * 2, true);
        this.ctx.closePath();
        this.ctx.fillStyle = color;
        this.ctx.fill();
    }
    drawCoordinatePlan(xMin = -5, xMax = 5, yMin = -5, yMax = 5) {
        const padding = 20;
        const innerWidth = this.width - 2 * padding;
        const innerHeight = this.height - 2 * padding;
        const mapX = (x)=>padding + (x - xMin) / (xMax - xMin) * innerWidth;
        const mapY = (y)=>this.height - padding - (y - yMin) / (yMax - yMin) * innerHeight;
        this.ctx.lineWidth = 1;
        this.ctx.setLineDash([]);
        // Draw the x-axis
        this.ctx.beginPath();
        this.ctx.moveTo(padding, this.centerY);
        this.ctx.lineTo(this.width - padding, this.centerY);
        this.ctx.strokeStyle = "#100c09";
        this.ctx.stroke();
        // Draw the y-axis
        this.ctx.beginPath();
        this.ctx.moveTo(this.centerX, padding);
        this.ctx.lineTo(this.centerX, this.height - padding);
        this.ctx.strokeStyle = "#100c09";
        this.ctx.stroke();
        // Draw ticks and labels on x-axis
        (0, $7gIxp.default)(xMin, xMax + 1).forEach((x, i)=>{
            const xPos = mapX(x);
            this.ctx.beginPath();
            this.ctx.moveTo(xPos, this.centerY - 5);
            this.ctx.lineTo(xPos, this.centerY + 5);
            this.ctx.stroke();
            if (x !== 0 && !(i % 2)) this.ctx.fillText(x, xPos - 3, this.centerY + 15);
        });
        // Draw ticks and labels on y-axis
        (0, $7gIxp.default)(yMin, yMax + 1).forEach((y, i)=>{
            const yPos = mapY(y);
            this.ctx.beginPath();
            this.ctx.moveTo(this.centerX - 5, yPos);
            this.ctx.lineTo(this.centerX + 5, yPos);
            this.ctx.stroke();
            if (y !== 0 && !(i % 2)) this.ctx.fillText(y, this.centerX + 10, yPos + 3);
        });
    }
}

});
parcelRegister("7gIxp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54ac9355d1c100e3$export$2e2bcd8739ae039; });
var $54ac9355d1c100e3$export$2e2bcd8739ae039 = (from, to, increment = 1)=>[
        ...Array(Math.ceil((to - from) / increment)).keys()
    ].map((i)=>from + i * increment);

});


parcelRegister("aYzlj", function(module, exports) {

$parcel$export(module.exports, "generateLinearData", function () { return $7fdaec4d1c0ed861$export$6c2fe876829088e1; });
$parcel$export(module.exports, "default", function () { return $7fdaec4d1c0ed861$export$2e2bcd8739ae039; });
const $7fdaec4d1c0ed861$var$getRandomBetween = (low, high)=>Math.random() * (high - low) + low;
const $7fdaec4d1c0ed861$export$5907fc7152c4333c = (nSamples)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples / 2
    }).forEach(()=>{
        const r = $7fdaec4d1c0ed861$var$getRandomBetween(0.05, 0.2);
        const t = Math.random() * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(1);
    });
    Array.from({
        length: nSamples / 2
    }).forEach(()=>{
        const r = $7fdaec4d1c0ed861$var$getRandomBetween(0.3, 0.45);
        const t = Math.random() * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(-1);
    });
    return [
        data,
        labels
    ];
};
const $7fdaec4d1c0ed861$export$6f53b2aedd0eab0b = (nSamples)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples / 2
    }).forEach((_, i)=>{
        const r = i / (nSamples / 2) * 0.5;
        const t = 1.25 * i / (nSamples / 2) * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(1);
    });
    Array.from({
        length: nSamples / 2
    }).forEach((_, i)=>{
        const r = i / (nSamples / 2) * 0.5;
        const t = 1.25 * i / (nSamples / 2) * 2 * Math.PI + Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(-1);
    });
    return [
        data,
        labels
    ];
};
const $7fdaec4d1c0ed861$export$6c2fe876829088e1 = (nSamples, fn = (x, y)=>y > 0.4 * x + 0.2 && -1 || 1)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples
    }).forEach(()=>{
        const x = $7fdaec4d1c0ed861$var$getRandomBetween(0, 0.99);
        const y = $7fdaec4d1c0ed861$var$getRandomBetween(0, 0.99);
        data.push([
            x,
            y
        ]);
        labels.push(fn(x, y));
    });
    return [
        data,
        labels
    ];
};
const $7fdaec4d1c0ed861$var$generatePatternData = (shape, nSamples)=>{
    switch(shape){
        case "circles":
            return $7fdaec4d1c0ed861$export$5907fc7152c4333c(nSamples);
        case "spirals":
            return $7fdaec4d1c0ed861$export$6f53b2aedd0eab0b(nSamples);
        case "linear":
            return $7fdaec4d1c0ed861$export$6c2fe876829088e1(nSamples);
        default:
            return [];
    }
};
var $7fdaec4d1c0ed861$export$2e2bcd8739ae039 = $7fdaec4d1c0ed861$var$generatePatternData;

});


var $d2Bw1 = parcelRequire("d2Bw1");

var $3RTuP = parcelRequire("3RTuP");

var $aYzlj = parcelRequire("aYzlj");

var $7gIxp = parcelRequire("7gIxp");

var $d2Bw1 = parcelRequire("d2Bw1");
const $7b6becb6cae14685$var$buildModel = ()=>{
    const layer1 = new (0, $d2Bw1.Layer)({
        numOfInputs: 2,
        numOfNeurons: 10
    });
    const layer2 = new (0, $d2Bw1.Layer)({
        numOfInputs: 10,
        numOfNeurons: 10
    });
    const layer3 = new (0, $d2Bw1.Layer)({
        numOfInputs: 10,
        numOfNeurons: 3,
        activation: "softmax"
    });
    const model = new (0, $d2Bw1.Sequential)({
        layers: [
            layer1,
            layer2,
            layer3
        ]
    });
    return model;
};
var $7b6becb6cae14685$export$2e2bcd8739ae039 = $7b6becb6cae14685$var$buildModel;



var $2P5ac = parcelRequire("2P5ac");
const $8a231f4f7e4e3d5f$var$size = Math.min(+document.querySelector(".demo").offsetWidth, 600);
const $8a231f4f7e4e3d5f$var$percent = (v)=>new Intl.NumberFormat("en-US", {
        style: "percent"
    }).format(v);
const $8a231f4f7e4e3d5f$var$oneHotEncode = (label, numClasses)=>{
    const encoding = Array(numClasses).fill(0);
    encoding[label] = 1;
    return encoding;
};
const $8a231f4f7e4e3d5f$var$crossEntropyLoss = (predictions, labels)=>{
    const n = predictions.length;
    return predictions.reduce((acc, pred, i)=>{
        const label = labels[i];
        const loss = pred.map((p, j)=>new (0, $d2Bw1.Value)(-label[j]).mul(p.log())).reduce((a, b)=>a.add(b), new (0, $d2Bw1.Value)(0));
        return acc.add(loss);
    }, new (0, $d2Bw1.Value)(0)).div(n);
};
const $8a231f4f7e4e3d5f$var$oneHotDecode = (values)=>{
    const probs = values.map((v)=>v.data);
    return probs.indexOf(Math.max(...probs));
};
class $8a231f4f7e4e3d5f$var$MultiClassClassification extends (0, $3RTuP.default) {
    constructor({ canvas: canvas, lossCanvas: lossCanvas }){
        super({
            canvas: canvas
        });
        this.lossCanvas = lossCanvas;
        this.ctxLoss = this.lossCanvas.getContext("2d");
        this.lossCanvas.setAttribute("width", $8a231f4f7e4e3d5f$var$size);
        this.lossCanvas.setAttribute("height", 200);
        this.model = (0, $7b6becb6cae14685$export$2e2bcd8739ae039)();
        this.training = false;
        this.trainId = null;
        this.drawId = null;
        this.maxEpochs = 500;
        this.trainingData = [];
        this.lossHistory = [];
    }
    mapX(x) {
        return this.padding + x * this.innerWidth;
    }
    mapY(y) {
        return this.height - this.padding - y * this.innerHeight;
    }
    plotPattern() {
        const [data, labels] = this.trainingData;
        data.forEach((point, index)=>{
            const [x, y] = point;
            const label = labels[index];
            const color = label === 2 && "#3a7ca5" || // blue
            label === 1 && "#f6511d" || // orange
            "#006632" // green
            ;
            this.drawCircle(this.mapX(x), this.mapY(y), 5, color);
        });
    }
    plotBoundaries() {
        const step = 0.05;
        const xRange = (0, $7gIxp.default)(0, 1, step);
        const yRange = (0, $7gIxp.default)(0, 1, step);
        yRange.forEach((y)=>{
            xRange.forEach((x)=>{
                const prediction = this.model.forward([
                    x,
                    y
                ]);
                const label = $8a231f4f7e4e3d5f$var$oneHotDecode(prediction);
                const color = label === 2 && "rgb(58 124 165 / 20%)" || // blue
                label === 1 && "rgb(246 81 29 / 20%)" || // orange
                "rgb(0 199 97 / 50%)" // green
                ;
                this.drawRectangle(this.mapX(x), this.mapY(y), step * this.innerWidth, step * this.innerHeight, color);
            });
        });
    }
    plotLossCurve() {
        const { lossCanvas: lossCanvas, ctxLoss: ctxLoss, lossHistory: lossHistory } = this;
        if (lossHistory.length < 2) return;
        const { width: width } = lossCanvas;
        const { height: height } = lossCanvas;
        const padding = 25;
        const plotWidth = width - 2 * padding;
        const plotHeight = height - 2 * padding;
        // Clear the previous plot
        ctxLoss.clearRect(0, 0, width, height);
        // Set up the drawing area
        ctxLoss.strokeStyle = "#856a5d";
        ctxLoss.lineWidth = 2;
        ctxLoss.beginPath();
        // Find the maximum loss for scaling
        const maxLoss = Math.max(...lossHistory);
        lossHistory.forEach((loss, index)=>{
            const x = padding + index / (this.maxEpochs - 1) * plotWidth;
            const y = height - padding - loss / maxLoss * plotHeight;
            if (index === 0) ctxLoss.moveTo(x, y);
            else ctxLoss.lineTo(x, y);
        });
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Draw x-axis
        ctxLoss.strokeStyle = "#100c09";
        ctxLoss.beginPath();
        ctxLoss.moveTo(padding, height - padding);
        ctxLoss.lineTo(width - padding, height - padding);
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Draw y-axis
        ctxLoss.beginPath();
        ctxLoss.moveTo(padding, height - padding);
        ctxLoss.lineTo(padding, padding);
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Add x-axis label
        ctxLoss.fillStyle = "#100c09";
        ctxLoss.font = "12px Arial";
        ctxLoss.fillText("Epochs", width / 2, height - padding / 4);
        // Add y-axis label
        ctxLoss.save();
        ctxLoss.translate(padding / 2, height / 2);
        ctxLoss.rotate(-Math.PI / 2);
        ctxLoss.textAlign = "center";
        ctxLoss.fillText("Loss", 0, 0);
        ctxLoss.restore();
    }
    train() {
        const [xs, ys] = this.trainingData;
        let epoch = 0;
        let learningRate = 0.5;
        const alpha = 1e-4;
        const batch = xs.length;
        const trainStep = ()=>{
            if (!this.training) return;
            // Shuffle and get batch indices
            let indices = (0, $7gIxp.default)(0, xs.length).sort(()=>Math.random() - 0.5);
            if (batch) indices = indices.slice(0, batch);
            const xsb = indices.map((index)=>xs[index]);
            const ysb = indices.map((index)=>ys[index]);
            const yPredictions = xsb.map((x)=>this.model.forward(x));
            const yTrue = ysb.map((label)=>$8a231f4f7e4e3d5f$var$oneHotEncode(label, 3));
            const dataLoss = $8a231f4f7e4e3d5f$var$crossEntropyLoss(yPredictions, yTrue);
            const regLoss = new (0, $d2Bw1.Value)(alpha).mul(this.model.parameters().reduce((acc, p)=>acc.add(p.pow(2)), new (0, $d2Bw1.Value)(0)));
            const totalLoss = dataLoss.add(regLoss);
            const correct = indices.filter((index, i)=>$8a231f4f7e4e3d5f$var$oneHotDecode(yPredictions[i]) === ys[index]).length;
            const accuracy = correct / yPredictions.length;
            // Backward pass
            this.model.zeroGrad();
            totalLoss.backward();
            // update weights
            learningRate *= 0.99;
            this.model.parameters().forEach((p)=>{
                p.data -= learningRate * p.grad;
            });
            this.model.epoch = epoch;
            this.model.loss = totalLoss.data;
            this.model.accuracy = accuracy;
            this.lossHistory.push(totalLoss.data);
            console.info(`Epoch: ${epoch}, Loss: ${totalLoss.data.toFixed(5)}, Accuracy: ${$8a231f4f7e4e3d5f$var$percent(accuracy)}, Learning Rate: ${learningRate.toFixed(5)}`);
            epoch += 1;
            if (epoch > this.maxEpochs) return;
            this.trainId = setTimeout(trainStep, 100);
        };
        trainStep();
    }
    setup() {
        this.model = (0, $7b6becb6cae14685$export$2e2bcd8739ae039)();
        this.trainingData = (0, $aYzlj.generateLinearData)(150, (x, y)=>y < -0.5 * x + 0.5 && 1 || y > 0.75 && 2 || 0);
        this.lossHistory = [];
        this.training = true;
        this.train();
        (0, $2P5ac.default)(".architecture", $8a231f4f7e4e3d5f$var$size, this.model.toString());
    }
    draw() {
        this.clear();
        this.plotBoundaries();
        this.plotPattern();
        this.plotLossCurve();
        const formatter = new Intl.NumberFormat("en-US", {
            style: "decimal",
            maximumFractionDigits: 0
        });
        document.querySelector("#epoch .value").innerText = formatter.format(this.model.epoch);
        document.querySelector("#loss .value").innerText = this.model.loss.toFixed(5);
        document.querySelector("#accuracy .value").innerText = $8a231f4f7e4e3d5f$var$percent(this.model.accuracy);
    }
    stop() {
        this.training = false;
        clearTimeout(this.trainId);
        cancelAnimationFrame(this.drawId);
    }
    restart() {
        this.stop();
        this.start();
    }
}
const $8a231f4f7e4e3d5f$var$classifier = new $8a231f4f7e4e3d5f$var$MultiClassClassification({
    canvas: document.getElementById("plane"),
    lossCanvas: document.getElementById("lossCurve"),
    padding: 0,
    width: $8a231f4f7e4e3d5f$var$size,
    height: $8a231f4f7e4e3d5f$var$size
});
$8a231f4f7e4e3d5f$var$classifier.start();

})();
//# sourceMappingURL=multiclass-classification.e146eb0a.js.map
